import PropTypes from 'prop-types'
import Divider from 'components/Divider'
import Stack from '@mui/material/Stack'

const ModalActions = ({
  centerAction,
  children,
}) => (
  <Stack width="100%">
    <Divider className="modal-actions__divider" color="neutral_200" />
    <Stack
      display="grid"
      gridAutoFlow="column"
      gap={2}
      py={2.5}
      px={3}
      alignItems="center"
      justifyContent={children?.length > 1 && !centerAction ? 'space-between' : 'center'}
    >
      {children}
    </Stack>
  </Stack>
)

ModalActions.propTypes = {
  centerAction: PropTypes.bool,
}

export default ModalActions
